<script setup>
import { computed, ref } from 'vue'
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  options: {
    type: Array,
    default: () => []
  },
  dropdown: {
    type: Boolean,
    default: false
  },
  multiple: {
    type: Boolean,
    default: false
  },
  forceSelection: {
    type: Boolean,
    default: false
  },
  optionLabel: {
    type: String
  },
  optionValue: {
    type: String
  }
})
const emit = defineEmits(['update:modelValue'])
const slots = useSlots()
const suggestions = ref([])
const objects = computed(() => props.options[0] && typeof props.options[0] === 'object')
const localVal = computed({
  get: () => {
    const key = props.optionValue ? props.optionValue : 'value'
    const label = props.optionLabel ? props.optionLabel : 'text'
    return objects.value ? props.options.find((opt) => opt[key] === props.modelValue)?.[label] : props.modelValue
  },
  set: (value) => {
    const inputValue = props.optionValue ? value[props.optionValue] : value.value || value
    emit('update:modelValue', inputValue)
  }
})
const search = (event) => {
  suggestions.value = props.options.filter((option) =>
    (props.optionLabel ? option[props.optionLabel] : option.text || option).toLowerCase().includes(event.query.toLowerCase()))
}
</script>

<template>
  <p-auto-complete
    v-model="localVal"
    :suggestions="suggestions"
    :option-label="props.optionLabel ? props.optionLabel : objects ? 'text' : undefined"
    placeholder="Type to Search..."
    :dropdown="dropdown"
    :multiple="props.multiple"
    @complete="search"
  >
    <template
      v-if="slots.option"
      #option="slotProps"
    >
      <slot
        name="option"
        v-bind="slotProps"
      />
    </template>
  </p-auto-complete>
</template>
